import React from 'react';
import { TableSkeleton } from 'components/atoms/table';

export const DemoTableSkeleton = () => {
  return (
    <>
      <TableSkeleton />
      <TableSkeleton size="large" />
      <TableSkeleton rowCount={10} columnCount={7} />
    </>
  );
};
